module.exports = __webpack_public_path__ + "img/show_cn_text_11.8f3aa349.png";